/**
 * Dynamic Shift Plan Table Configuration
 *
 * This configuration defines how the table displays data for different metrics (volume, headcount, rate).
 * Each metric has process categories that can be configured independently.
 *
 * Configuration Structure:
 * - key: Internal identifier for the process category
 * - displayName: User-friendly name shown in table headers
 * - showPlannedVsActual: Boolean flag controlling column display mode
 *   - true: Shows "PvA" (Planned vs Actual) and "Delta" columns
 *   - false: Shows only "Actual" column
 * - defaultExpanded: Boolean flag controlling initial expanded state (defaults to false)
 * - processes: Array of sub-processes that can be expanded under this category
 *
 * To modify display behavior:
 * 1. Change showPlannedVsActual to true/false for any process category
 * 2. Add/remove processes in the processes array
 * 3. Update displayName to change header text
 */

import { processMapping } from '../../utils/constants';

export const AGGREGATE_COLUMNS_CONFIG = {
  volume: [
    {
      key: 'Inducted',
      displayName: 'Induct',
      showPlannedVsActual: false,
      defaultExpanded: false,
      processes: [
        { key: 'Automated Inducted', displayName: 'Automated Inducted' }, // Old name for (ASML + ASL). Delete after Week 36.
        { key: 'ASML Inducted', displayName: 'ASML Inducted' },
        { key: 'ASL Inducted', displayName: 'ASL Inducted' },
        { key: 'Manual Inducted', displayName: 'Manual Inducted' }
      ]
    },
    {
      key: 'Sortation', // Yes, this is incorrect and should be 'Stowed'. Yes, the backend needs to correct itself. Yes, the graph will also need to be updated.
      displayName: 'Stow',
      showPlannedVsActual: false,
      defaultExpanded: false,
      processes: [
        { key: 'ADTA Container Building', displayName: 'ADTA Container Building' },
        { key: 'Container Building', displayName: 'Container Building' }
      ]
    },
    { key: 'Outbound', displayName: 'Pick Stage', showPlannedVsActual: true, defaultExpanded: true, processes: [] }
  ],
  headcount: [
    {
      key: 'Overall',
      displayName: 'Total Needed vs. Punch In',
      showPlannedVsActual: true,
      defaultExpanded: false,
      processes: []
    },
    {
      key: 'Rostered',
      displayName: 'Expected vs. Punch In',
      showPlannedVsActual: true,
      defaultExpanded: false,
      processes: []
    },
    {
      key: 'Sort',
      displayName: 'Sort',
      showPlannedVsActual: false,
      defaultExpanded: false,
      processes: [...processMapping['Sort'].map((process) => ({ key: process, displayName: process }))]
    },
    {
      key: 'Pick Stage',
      displayName: 'Pick Stage',
      showPlannedVsActual: true,
      defaultExpanded: true,
      processes: [...processMapping['Pick Stage'].map((process) => ({ key: process, displayName: process }))]
    },
    {
      key: 'other',
      displayName: 'Other',
      showPlannedVsActual: false,
      defaultExpanded: false,
      processes: [
        ...processMapping['UTR'].map((process) => ({ key: process, displayName: process })),
        ...processMapping['Site Support'].map((process) => ({ key: process, displayName: process }))
      ]
    }
  ],
  rate: [
    {
      key: 'Sort',
      displayName: 'Sort',
      showPlannedVsActual: false,
      defaultExpanded: false,
      processes: processMapping['Sort'].map((process) => ({ key: process, displayName: process }))
    },
    {
      key: 'Outbound',
      displayName: 'Pick Stage',
      showPlannedVsActual: true,
      defaultExpanded: true,
      processes: processMapping['Pick Stage'].map((process) => ({ key: process, displayName: process }))
    }
  ]
};
